import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

import { BreadcrumbTrail, SeoBreadcrumbJsonLd } from './Breadcrumbs'

interface Props {
  items: BreadcrumbItem[]
  className?: string
}

const StaticBreadcrumbs: React.FC<Props> = ({ items, className }) => (
  <>
    <SeoBreadcrumbJsonLd items={items} />
    <BreadcrumbTrail items={items} className={className} />
  </>
)

export default StaticBreadcrumbs
